<div #footerContainer class="compact-footer">
	<div>
		<ng-container *ngTemplateOutlet="customTemplate || defaultTemplate"></ng-container>
	</div>
	<a obgCustomerSupportLink (click)="supportClick.emit()">
		{{ "general.contact-support" | translate }}
		<span class="ico-live-chat"></span>
	</a>
</div>

<ng-template #defaultTemplate>
	<img *ngIf="showJurisdictionLicenseLogo" obgImageContent="general.footer-jurisdiction-small-logo" />
	<img obgImageContent="general.footer-pci" />
	<img obgImageContent="general.footer-secure" />
	<img *ngIf="showLicenseLogo" obgImageContent="general.footer-mga-logo" />
</ng-template>
